export function updateErrorsFunc(state, action) {
    state[action.payload.key] = action.payload.value;
    return state;
}
